/**
 * @summary - Component that Provides Asset Lifecycle Report Page
 * @author charumathisekar
 * @since 2024-08-08
 */

import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Grid, Modal} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';
import PageLoader from "../commoncomponents/PageLoader";
import "../../assets/css/reports.css";
import "../../assets/css/assetreport.css";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from '../commoncomponents/CustomTextFieldWithSearch';
import { getAuthToken } from "../../utility/tokenUtility";
import { FemsGraph, BemsGraph } from "../../utility/apiURLS";
import PageTitle from "../commoncomponents/PageTitle";
import { useDispatch } from "react-redux";
import CustomDialog from "../commoncomponents/CustomDialog";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import Assetcycleprint from '../../components/assetlifecyclecomponents/AssetcyclePrint';
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
const Assetlifereports = () => {
    const navigate = useNavigate();
    const [isView, setIsView] = useState(false);
    const childRef = useRef(null);
    const [readOnly, setReadOnly] = useState(false);
    const [readOnlyEdit, setReadOnlyEdit] = useState(false);
    const [assetNo, setAssetNo] = useState(null);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [assetDescription, setAssetDescription] = useState('');
    const [service, setService] = useState('');
    const [showDetails, setShowDetails] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [reportdata, setReportData] = useState([]);
    const [assetNoError, setAssetNoError] = useState("");
    const dispatch = useDispatch();
    const token = getAuthToken("id_token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGA004");
    const facilityId = localStorage.getItem('facilityId');
  
    const ModalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "1200px",
        height: "100%",
        maxHeight: "calc(100% - 64px)",
        bgcolor: "#fff",
        boxShadow: 24,
        borderRadius: "5px",
        p: 4,
        overflowY: "auto",
        overflowX: "hidden",
    };
    

    useEffect(() => {
        if (!assetNo) {

            setService("");
            setAssetDescription("");
        }
    }, [assetNo]);


    const fetchOptions = async () => {
        try {
            const femsResponse = await Axios.get(`${FemsGraph}/api/GraphFemsAssetregisterlist/GetAssetRegisterListFetch/${facilityId}`, config);
            const bemsResponse = await Axios.get(`${BemsGraph}/api/GraphBemsAssetregisterlist/GetAssetRegisterListFetch/${facilityId}`, config);
            const combinedData = [...femsResponse.data, ...bemsResponse.data];
            const reArrangedData = combinedData.map((item) => ({
                label: `${item.assetNo} - ${item.assetdesc}`,
                value: item.assetdesc,
                assetNo: item.assetNo,
                id: item.id,
                serviceName: item.serviceName,
                assetdesc: item.assetdesc,
            }));

            setOptions(reArrangedData);



        } catch (error) {

        }
    }

    const handleAssetNoChange = (newValue) => {
        if (newValue) {
            setAssetNo(newValue ? { ...newValue, label: newValue.label.split('-')[0].trimRight() } : '');
            setService(newValue.serviceName || '');
            setAssetDescription(newValue.assetdesc || '');
            localStorage.setItem('defaultAssetNo', newValue.assetNo);
        } else {
            setAssetNo(null);
            setService("");
            setAssetDescription("");
        }
    };
    const handleCancel = () => {
        if (!assetNo && !assetDescription && !service) {
            navigate("/dashboard");
            dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
            dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
        } else {
            setCancelDialogOpen(true);
        }

    };

    const handleOpenModal = () => {
        setOpenModal(true);
        setShowDetails(true);
    };
    const handleCancelConfirm = () => {
        setCancelDialogOpen(false);
        navigate("/dashboard");
        dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
        dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
    };
    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };


    const fetchReportData = async () => {
        try {
            const assetId = assetNo.id;
            const service = assetNo.serviceName;
            let response;

            if (service === "FEMS") {
                response = await Axios.get(`${FemsGraph}/api/AssetLifeCycleReport/${assetId}?size=1000`, config);
            } else if (service === "BEMS") {
                response = await Axios.get(`${BemsGraph}/api/AssetLifeCycleReport/${assetId}?size=1000`, config);
            } else {
                console.error("Unknown service:", service);
                return;
            }

            const reportdata = Array.isArray(response.data) ? response.data[0] : response.data;
            setReportData(reportdata);
            handleOpenModal();
        } catch (error) {
            console.error("Error fetching report data:", error);
        }
    };
    useEffect(() => {
        fetchReportData();
        fetchOptions();
    }, []);
    const handleViewButtonClick = async () => {
        setIsView(true);
        if (!assetNo || !assetNo.id) {
            setAssetNoError("Asset No is required");
            return;
        }
        setAssetNoError("");
        setLoading(true);
        try {
            await fetchReportData();
            setOpenModal(true);
        } catch (error) {
            console.error("Error handling view button click:", error);

        }
        finally {
            setLoading(false);
        }
    };
    const handleDownloadPDF = async () => {
        if (!assetNo || !assetNo.id) {
            setAssetNoError("Asset No is required");
            return;
        }
    
        setLoading(true);
    
        try {
            await fetchReportData();
            setIsView(false);
            setOpenModal(true);
    
            setTimeout(async () => {
                try {
                    if (childRef.current) {
                        await childRef.current.handleDownloadPDF();
                    }
                } catch (error) {
        
                } finally {
                    setLoading(false); 
                }
            }, 1000);
        } catch (error) {
           
            setLoading(false);
        }
    };
    
    return (
        <>
            <PageLoader open={loading} />
            <PageTitle title={"Asset Life Cycle Cost Analysis"} />

            <Box mt={{ xs: 1, sm: 2 }}>
                <DefaultCard>
                    <Grid container spacing={2}>
                        <Grid item xs={6} md={4}>
                            <CustomTextFieldWithSearch
                                label="Asset No"
                                name="Asset No"
                                id="Asset No"
                                options={options}
                                value={assetNo}
                                getOptionLabel={(option) => option.assetNo}
                                isOptionEqualToValue={(option, value) => option.assetNo === value.assetNo}
                                disabled={readOnly || readOnlyEdit}
                                isMandatoryField={true}
                                autoFocus={true}
                                onChange={(event, newValue) => {
                                    handleAssetNoChange(event, newValue);
                                    setAssetNoError("");
                                }}
                                error={!!assetNoError}
                                helperText={assetNoError}
                            />
                        </Grid>

                        <Grid item xs={6} md={4}>
                            <CustomTextField
                                label="Asset Description"
                                name="Asset Description"
                                disabled={readOnly || readOnlyEdit}
                                isRefilByOtherField={true}
                                placeholder={false}
                                value={assetDescription}
                            />
                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomTextField
                                label="Service"
                                name="Service"
                                disabled={readOnly || readOnlyEdit}
                                isRefilByOtherField={true}
                                placeholder={false}
                                value={service}
                            />
                        </Grid>
                    </Grid>

                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "end" },
                            mt: 3,
                        }}
                    >
                        <Button variant='contained' onClick={handleViewButtonClick}>View</Button>
                        {access?.canPrint && <Button variant='contained' onClick={handleDownloadPDF}>Download </Button>}
                        <Button variant='outlined' onClick={handleCancel}>Close</Button>

                    </Box>
                </DefaultCard>
            </Box>
            <Modal
                open={openModal}
                sx={
                    !isView && {
                        "& .MuiBackdrop-root": {
                            backgroundColor: "transparent",
                        },
                        top: "-9999px",
                        left: "-9999px",
                        zIndex: "-1",
                    }
                }
            >
            

                <Box sx={ModalStyle}>
                    <Assetcycleprint
                        assetNo={assetNo}
                        service={service}
                        assetDescription={assetDescription}
                        setOpenModal={setOpenModal}
                        reportdata={reportdata}
                        ref={childRef}
                        setIsView={setIsView}
                    />
   
   </Box>



</Modal>
            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                onConfirm={handleCancelConfirm}
                title="Cancel Confirmation"
                content="Do you want to continue?"
                cancelBtn="No"
                confirmBtn="Yes"
            />
        </>
    );

}
export default Assetlifereports;
